/* Cohynsa · Taller de Ensamble — motor 3D (three.js r128)
 * Gemelo del ensamble: manguera + conexiones modeladas con las PROPORCIONES REALES
 * del catálogo (medidas tomadas de los renders Aeroquip; mismas razones que
 * mf-assembler.js, todas relativas a R = radio exterior de la manguera):
 *   campana de crimpado 1.109R × 2.043R con 5 ranuras y collares de alivio,
 *   escalón 0.826R, cuello 0.543R con ranuras finas, tuerca hex 1.882R entre caras,
 *   rosca macho paso 0.191R con cono JIC 37°, hembra con barril moleteado r=1R y
 *   boca avellanada, codos = tubo doblado radio 1.304R (nunca esquina dura).
 * La manguera usa el color de banda REAL de cada familia (GH781 verde, GH493
 * amarilla, FC606 morada, GH195 azul…) con su nombre impreso.
 *
 * API global:
 *   Kit3D.init({ canvas, holder })
 *   Kit3D.update(state)  state = { hose:{label,family}|null,
 *                                  A:{geom,gender}|null, B:{geom,gender}|null,
 *                                  meters:Number, angleB:Number }
 *        geom: 'recta'|'codo45'|'codo90'|'codo90L' · gender: 'macho'|'hembra'
 *   Kit3D.setAutoRotate(bool) · Kit3D.resetView()
 * Los adaptadores aún no se dibujan (pendiente de mapeo).
 */
(function (root) {
  'use strict';
  if (root.Kit3D) return;

  var T = root.THREE;
  var K = {};
  var renderer, scene, camera, world, asm, standGroup, composer = null;
  var matChrome, matSteel, matNut, matRubber, matDark, matBore, matGhost, matBlock, matSlab, matRed;
  var groups = { hose: null, A: null, B: null };
  var keys = { hose: '', A: '', B: '' };
  var tweens = [];
  var autoRotate = true, dragging = false;
  var rotX = 0.34, rotY = -0.55, dist = 8.7;
  var targetRotX = rotX, targetRotY = rotY, targetDist = dist;
  var ready = false, holderEl = null;
  var reduced = false;
  try { reduced = root.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* ============ proporciones REALES (R = 1 = radio de la manguera) ============ */
  var P = {
    sockR: 1.109,     // radio del barril de la campana (25.5/23)
    sockL: 2.043,     // largo de la campana (47/23)
    grooveXs: [0.341, 0.681, 1.022, 1.362, 1.703],   // 5 ranuras de crimpado
    stepR: 0.826, stepL: 0.174,
    neckR: 0.543, neckL: 0.478,
    hexAF: 1.882,     // tuerca: distancia entre caras (2 × 25/23 × cos30)
    hexL: 1.609,      // largo de la tuerca (37/23)
    threadRoot: 0.496, threadMajor: 0.587, threadPitch: 0.191,
    threadL: 1.196,   // zona roscada (antes del cono)
    noseL: 0.248, noseR: 0.293,          // cono JIC 37°
    swvR: 1.0, swvL: 0.913,              // barril moleteado hembra (r = R exacto)
    boreR: 0.700,                        // barreno de la boca hembra
    tubeR: 0.543, bendR: 1.304,          // codo: tubo doblado
    elbowCollar: 0.304,
    armExtra: { codo45: 0.5, codo90: 0.72, codo90L: 2.6 },
    hoseR: 1.0
  };
  var WORLD_R = 0.30;   // 1 R = 0.30 unidades de mundo

  /* estilos reales por familia de manguera (banda + texto impresos) */
  var FAMILIES = {
    GH781: { band: '#1f8a43', text: '#ffffff', name: 'AEROQUIP GH781' },
    GH793: { band: '#c22a33', text: '#ffffff', name: 'AEROQUIP GH793' },
    GH195: { band: '#c9a227', text: '#10233f', cover: 0x1b3f8f, name: 'AEROQUIP GH195' },
    GH493: { band: '#e8b820', text: '#132433', name: 'AEROQUIP GH493' },
    FC500: { band: '#e07a1f', text: '#ffffff', name: 'AEROQUIP FC500' },
    FC254: { band: '#c22a33', text: '#ffffff', name: 'AEROQUIP FC254' },
    FC606: { band: '#6a3b9c', text: '#ffffff', name: 'AEROQUIP FC606' },
    EC215: { band: '#101216', text: '#ffffff', name: 'WINNER EC215' },
    '1503': { band: null,     text: '#ffffff', name: 'AEROQUIP 1503' }
  };
  function familyOf(label) {
    var s = String(label || '').toUpperCase();
    for (var k in FAMILIES) if (s.indexOf(k) >= 0) return k;
    return null;
  }

  /* ============ utilidades ============ */
  function lerp(a, b, k) { return a + (b - a) * k; }
  function easeOutBack(k) { var c = 1.70158; return 1 + (c + 1) * Math.pow(k - 1, 3) + c * Math.pow(k - 1, 2); }
  function easeOutCubic(k) { return 1 - Math.pow(1 - k, 3); }
  function tween(dur, fn, ease, done) {
    if (reduced) { fn(1); if (done) done(); return; }
    tweens.push({ t0: performance.now(), dur: dur, fn: fn, ease: ease || easeOutCubic, done: done });
  }
  function stepTweens(now) {
    for (var i = tweens.length - 1; i >= 0; i--) {
      var w = tweens[i], k = Math.min(1, (now - w.t0) / w.dur);
      w.fn(w.ease(k));
      if (k >= 1) { tweens.splice(i, 1); if (w.done) w.done(); }
    }
  }
  function castAll(g) {
    g.traverse(function (o) { if (o.isMesh) { o.castShadow = true; } });
  }
  function disposeDeep(g) {
    g.traverse(function (o) {
      if (o.geometry) o.geometry.dispose();
      var m = o.material;
      if (m && m.userData && m.userData.disposable) {
        if (m.map) m.map.dispose();
        if (m.userData.disposeBump && m.bumpMap) m.bumpMap.dispose();
        if (m.userData.disposeNormal && m.normalMap) m.normalMap.dispose();
        m.dispose();
      }
    });
  }

  /* ============ entorno: reflejos de estudio (fondo claro) ============ */
  // ============ entorno de ESTUDIO 2048x1024 (canvas-only, sin fetch) ============
  // Equirect: x=0..W -> azimut 0..360; y=0..H -> cenit(0) a nadir(H).
  // Softbox nítido de alto contraste = reflejos de cromo creíbles.
  function makeEnvTexture() {
    var W = 2048, H = 1024;
    var c = document.createElement('canvas'); c.width = W; c.height = H;
    var x = c.getContext('2d');

    // --- degradado base: techo(brillante) -> horizonte(medio) -> piso(oscuro c/rebote)
    var g = x.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0.00, '#fbfcff'); g.addColorStop(0.28, '#eef1f5');
    g.addColorStop(0.46, '#c4c9d0'); g.addColorStop(0.50, '#9aa0a8'); // zona horizonte
    g.addColorStop(0.54, '#5b6068'); g.addColorStop(0.72, '#2c2f34');
    g.addColorStop(0.88, '#191b1f'); g.addColorStop(1.00, '#0e0f12');
    x.fillStyle = g; x.fillRect(0, 0, W, H);

    // --- LÍNEA DE HORIZONTE nítida (define la curvatura en el cromo)
    var hl = x.createLinearGradient(0, H*0.485, 0, H*0.515);
    hl.addColorStop(0, 'rgba(18,20,24,0)'); hl.addColorStop(0.5, 'rgba(18,20,24,0.55)'); hl.addColorStop(1, 'rgba(18,20,24,0)');
    x.fillStyle = hl; x.fillRect(0, H*0.485, W, H*0.03);

    // --- REBOTE DE PISO cálido en el tercio inferior (evita el vacío negro)
    var fb = x.createLinearGradient(0, H*0.66, 0, H);
    fb.addColorStop(0, 'rgba(120,110,104,0)'); fb.addColorStop(0.7, 'rgba(150,138,128,0.10)'); fb.addColorStop(1, 'rgba(178,166,152,0.22)');
    x.fillStyle = fb; x.fillRect(0, H*0.66, W, H*0.34);

    function rr(cx, cy, w, h, rad) {
      var l=cx-w/2,t=cy-h/2,r=cx+w/2,b=cy+h/2;
      x.beginPath(); x.moveTo(l+rad,t); x.lineTo(r-rad,t); x.arcTo(r,t,r,t+rad,rad);
      x.lineTo(r,b-rad); x.arcTo(r,b,r-rad,b,rad); x.lineTo(l+rad,b); x.arcTo(l,b,l,b-rad,rad);
      x.lineTo(l,t+rad); x.arcTo(l,t,l+rad,t,rad); x.closePath();
    }
    // --- SOFTBOX de estudio = marco oscuro + panel brillante nítido + halo suave
    function softbox(cx, cy, w, h, core) {
      var bl = x.createRadialGradient(cx,cy, Math.min(w,h)*0.25, cx,cy, Math.max(w,h)*0.9);
      bl.addColorStop(0, 'rgba(255,255,255,'+(core*0.5)+')'); bl.addColorStop(1, 'rgba(255,255,255,0)');
      x.fillStyle = bl; x.fillRect(cx-w, cy-h, w*2, h*2);
      x.fillStyle = 'rgba(30,33,38,0.92)'; rr(cx, cy, w+26, h+26, 24); x.fill();   // marco
      var pg = x.createLinearGradient(0, cy-h/2, 0, cy+h/2);
      pg.addColorStop(0, 'rgba(255,255,255,'+core+')'); pg.addColorStop(1, 'rgba(236,241,248,'+(core*0.82)+')');
      x.fillStyle = pg; rr(cx, cy, w, h, 16); x.fill();                            // panel (borde nítido)
      x.fillStyle = 'rgba(40,44,50,0.28)'; x.fillRect(cx-2, cy-h/2, 4, h); x.fillRect(cx-w/2, cy-2, w, 4); // baffles
    }
    softbox(560, 300, 620, 300, 0.98);   // KEY grande, superior-frontal
    softbox(1500, 250, 380, 210, 0.72);  // FILL opuesto, menor/tenue

    // --- TIRAS RIM verticales (cantos brillantes en el cromo); la de x~0 cruza la costura
    function rimStrip(cx, w, a) {
      var rg = x.createLinearGradient(cx-w, 0, cx+w, 0);
      rg.addColorStop(0,'rgba(255,255,255,0)'); rg.addColorStop(0.5,'rgba(255,255,255,'+a+')'); rg.addColorStop(1,'rgba(255,255,255,0)');
      x.fillStyle = rg; x.fillRect(cx-w, H*0.12, w*2, H*0.6);
    }
    rimStrip(30, 46, 0.85); rimStrip(W-30, 46, 0.85); rimStrip(1030, 30, 0.5);

    // --- KICKS ROJO DE MARCA (sutiles)
    function redKick(cx, cy, r, a) {
      var rg = x.createRadialGradient(cx,cy, 8, cx,cy, r);
      rg.addColorStop(0,'rgba(206,51,60,'+a+')'); rg.addColorStop(1,'rgba(206,51,60,0)');
      x.fillStyle = rg; x.fillRect(0,0,W,H);
    }
    redKick(1580, 560, 420, 0.22); redKick(300, 640, 340, 0.14);

    var tex = new T.CanvasTexture(c);
    tex.mapping = T.EquirectangularReflectionMapping; tex.needsUpdate = true;
    return tex;
  }
  // NOTA: PMREM ya consume esta equirect en init(); no cambia la llamada existente.

  /* ============ texturas ============ */
  function makeRubberBump() {
    // trama de tela impresa (como el forro real): tejido diagonal fino en 2 direcciones
    // + costillas transversales sutiles del envolvido en espiral
    var c = document.createElement('canvas'); c.width = 256; c.height = 256;
    var x = c.getContext('2d');
    x.fillStyle = '#808080'; x.fillRect(0, 0, 256, 256);
    x.globalAlpha = 0.5; x.lineWidth = 1.1;
    x.strokeStyle = '#8e8e8e';
    for (var i = -256; i < 512; i += 6) {
      x.beginPath(); x.moveTo(i, 0); x.lineTo(i + 256, 256); x.stroke();
      x.beginPath(); x.moveTo(i + 256, 0); x.lineTo(i, 256); x.stroke();
    }
    x.globalAlpha = 0.22; x.strokeStyle = '#6f6f6f'; x.lineWidth = 2;
    for (var r = 0; r <= 256; r += 26) { x.beginPath(); x.moveTo(0, r); x.lineTo(256, r); x.stroke(); }
    x.globalAlpha = 0.14; x.strokeStyle = '#9a9a9a';
    for (var r2 = 13; r2 <= 256; r2 += 26) { x.beginPath(); x.moveTo(0, r2); x.lineTo(256, r2); x.stroke(); }
    var tex = new T.CanvasTexture(c);
    tex.wrapS = tex.wrapT = T.RepeatWrapping; tex.repeat.set(8, 3);
    return tex;
  }
  function makeKnurlBump() {
    var c = document.createElement('canvas'); c.width = 128; c.height = 64;
    var x = c.getContext('2d');
    x.fillStyle = '#808080'; x.fillRect(0, 0, 128, 64);
    x.strokeStyle = '#c9c9c9'; x.lineWidth = 2;
    for (var i = 0; i <= 128; i += 5) { x.beginPath(); x.moveTo(i, 6); x.lineTo(i, 58); x.stroke(); }
    var tex = new T.CanvasTexture(c);
    tex.wrapS = tex.wrapT = T.RepeatWrapping; tex.repeat.set(8, 1);
    return tex;
  }
  /* Textura de la manguera: hule + FRANJA LONGITUDINAL real (layline) con el nombre
     de la familia impreso a lo largo del eje, como en las fotos del catálogo.
     u = alrededor de la circunferencia, v = a lo largo del eje. */
  /* ============ MANGUERA: color 4K (2048x4096) ============ */
  /* weavePass reescalado para el canvas 2x mayor (paso y grosor duplicados). */
  function weavePass(x, W, Hh, lightA, darkA) {
    var step = 18;                 // 2x del original (canvas 2x mayor) -> misma escala relativa
    x.lineWidth = 4.4;
    x.strokeStyle = 'rgba(255,255,255,' + lightA + ')';
    for (var i = -Hh; i < W + Hh; i += step) {
      x.beginPath(); x.moveTo(i, 0); x.lineTo(i + Hh, Hh); x.stroke();
    }
    x.strokeStyle = 'rgba(0,0,0,' + darkA + ')';
    for (var j = -Hh; j < W + Hh; j += step) {
      x.beginPath(); x.moveTo(j + Hh, 0); x.lineTo(j, Hh); x.stroke();
    }
  }

  function makeHoseTexture(fam) {
    var st = (fam && FAMILIES[fam]) || { band: '#CE333C', text: '#ffffff', name: 'COHYNSA' };
    var W = 2048, Hh = 4096;                        // 4K, u=circunferencia, v=eje
    var c = document.createElement('canvas'); c.width = W; c.height = Hh;
    var x = c.getContext('2d');
    var cover = st.cover ? '#' + st.cover.toString(16).padStart(6, '0') : '#101216';
    x.fillStyle = cover; x.fillRect(0, 0, W, Hh);

    // profundidad tonal del hule: sombra hacia los "hombros" del mapa
    var sg = x.createLinearGradient(0, 0, W, 0);
    sg.addColorStop(0, 'rgba(0,0,0,0.16)'); sg.addColorStop(0.25, 'rgba(255,255,255,0.05)');
    sg.addColorStop(0.5, 'rgba(0,0,0,0.10)'); sg.addColorStop(0.75, 'rgba(255,255,255,0.05)');
    sg.addColorStop(1, 'rgba(0,0,0,0.16)');
    x.fillStyle = sg; x.fillRect(0, 0, W, Hh);

    // TEJIDO TEXTIL dibujado EN EL COLOR (pasada global)
    weavePass(x, W, Hh, st.cover ? 0.02 : 0.028, 0.08);

    // COVER DE COLOR: pasada multiplicativa -> tono profundo y saturado
    if (st.cover) {
      x.globalCompositeOperation = 'multiply'; x.globalAlpha = 0.5;
      x.fillStyle = cover; x.fillRect(0, 0, W, Hh);
      x.globalCompositeOperation = 'source-over'; x.globalAlpha = 1;
    }

    // costillas del envolvido en espiral (paso 2x del original)
    x.globalAlpha = 0.05; x.fillStyle = '#000000';
    for (var vr = 0; vr < Hh; vr += 88) x.fillRect(0, vr, W, 14);
    x.globalAlpha = 0.045; x.fillStyle = '#ffffff';
    for (var vr2 = 44; vr2 < Hh; vr2 += 88) x.fillRect(0, vr2, W, 10);
    x.globalAlpha = 1;

    // DOS laylines OPUESTAS con impresion NITIDA y GRANDE (repetida a lo largo del eje)
    var uW = 336, txt = (st.name || 'COHYNSA').toUpperCase();
    [288, 1312].forEach(function (u0) {                 // 2x de [144,656]
      if (st.band) {
        x.fillStyle = st.band; x.fillRect(u0, 0, uW, Hh);
        // el tejido asoma SOLO dentro de la franja (color saturado)
        x.save(); x.beginPath(); x.rect(u0, 0, uW, Hh); x.clip();
        weavePass(x, W, Hh, 0.04, 0.05);
        x.globalCompositeOperation = 'multiply'; x.globalAlpha = 0.22;
        x.fillStyle = st.band; x.fillRect(u0, 0, uW, Hh);
        x.globalCompositeOperation = 'source-over'; x.globalAlpha = 1;
        x.restore();
        // filetes blancos de borde de franja
        x.fillStyle = 'rgba(255,255,255,0.8)';
        x.fillRect(u0 + 10, 0, 7, Hh); x.fillRect(u0 + uW - 16, 0, 7, Hh);
      }
      // texto de familia: mas grande y nitido (208px) a lo largo del eje
      x.fillStyle = st.text || '#ffffff';
      x.font = '700 150px "Arial Narrow", "Helvetica Neue", Arial, sans-serif';
      x.textAlign = 'center'; x.textBaseline = 'middle';
      [683, 2048, 3413].forEach(function (vy) {   // 3 rótulos por tile, sin solape
        x.save(); x.translate(u0 + uW / 2, vy); x.rotate(Math.PI / 2);
        x.fillText(txt, 0, 0); x.restore();
      });
    });

    var tex = new T.CanvasTexture(c);
    tex.anisotropy = 16;
    tex.wrapS = tex.wrapT = T.RepeatWrapping;
    tex.offset.x = 0.055;                              // franjas a los LADOS (frente y atras)
    tex.needsUpdate = true;
    // NOTA: la densidad axial (map.repeat.y ~ L/3.6) la fija buildHose por-largo.
    return tex;
  }

  /* ============ Sobel canvas -> normal tangente (compartido) ============ */
  /* Lee el canal ROJO como campo de ALTURA, envuelve en los bordes para tiling
     sin costura, y escribe RGB = normal empaquetada. sx/sy permiten anisotropia. */
  function sobelNormalTexture(heightCanvas, strength, opts) {
    var W = heightCanvas.width, Hh = heightCanvas.height;
    var src = heightCanvas.getContext('2d').getImageData(0, 0, W, Hh).data;
    var out = document.createElement('canvas'); out.width = W; out.height = Hh;
    var octx = out.getContext('2d');
    var dst = octx.createImageData(W, Hh); var d = dst.data;
    var sx = (opts && opts.sx != null) ? opts.sx : strength;
    var sy = (opts && opts.sy != null) ? opts.sy : strength;
    function h(px, py) {
      if (px < 0) px += W; else if (px >= W) px -= W;     // wrap horizontal (circunferencia)
      if (py < 0) py += Hh; else if (py >= Hh) py -= Hh;  // wrap vertical (eje)
      return src[(py * W + px) * 4] / 255;
    }
    for (var y = 0; y < Hh; y++) {
      for (var xx = 0; xx < W; xx++) {
        var tl = h(xx - 1, y - 1), tc = h(xx, y - 1), tr = h(xx + 1, y - 1);
        var ml = h(xx - 1, y),                          mr = h(xx + 1, y);
        var bl = h(xx - 1, y + 1), bc = h(xx, y + 1), br = h(xx + 1, y + 1);
        var gx = (tr + 2 * mr + br) - (tl + 2 * ml + bl);
        var gy = (bl + 2 * bc + br) - (tl + 2 * tc + tr);
        var nx = -gx * sx, ny = -gy * sy, nz = 1;
        var inv = 1 / Math.sqrt(nx * nx + ny * ny + nz * nz);
        var idx = (y * W + xx) * 4;
        d[idx]     = (nx * inv * 0.5 + 0.5) * 255;
        d[idx + 1] = (ny * inv * 0.5 + 0.5) * 255;
        d[idx + 2] = (nz * inv * 0.5 + 0.5) * 255;
        d[idx + 3] = 255;
      }
    }
    octx.putImageData(dst, 0, 0);
    var tex = new T.CanvasTexture(out);
    tex.wrapS = tex.wrapT = T.RepeatWrapping;
    return tex;
  }

  /* Campo de ALTURA del tejido (misma escala relativa que el color: paso/2048 identico). */
  function drawWeaveHeight(x, W, Hh) {
    var step = 9;                                        // 9/1024 == 18/2048 del color
    // valles (oscuros) en ambas diagonales
    x.lineWidth = 3.4; x.strokeStyle = 'rgba(0,0,0,0.5)';
    for (var i = -Hh; i < W + Hh; i += step) {
      x.beginPath(); x.moveTo(i, 0); x.lineTo(i + Hh, Hh); x.stroke();
      x.beginPath(); x.moveTo(i + Hh, 0); x.lineTo(i, Hh); x.stroke();
    }
    // crestas (claras) desfasadas medio paso -> hilos por encima (over/under)
    x.lineWidth = 2.0; x.strokeStyle = 'rgba(255,255,255,0.55)';
    var o = step * 0.5;
    for (var k = -Hh; k < W + Hh; k += step) {
      x.beginPath(); x.moveTo(k + o, 0); x.lineTo(k + o + Hh, Hh); x.stroke();
      x.beginPath(); x.moveTo(k + o + Hh, 0); x.lineTo(k + o, Hh); x.stroke();
    }
  }

  /* NORMAL de la manguera desde el HEIGHT del tejido (1024x2048; tilea igual que el color). */
  function makeHoseNormal(fam) {
    var st = (fam && FAMILIES[fam]) || { band: '#CE333C', name: 'COHYNSA' };
    var W = 1024, Hh = 2048;                             // media res del color: normal no necesita 4K
    var c = document.createElement('canvas'); c.width = W; c.height = Hh;
    var x = c.getContext('2d');
    x.fillStyle = '#808080'; x.fillRect(0, 0, W, Hh);    // altura media
    drawWeaveHeight(x, W, Hh);

    // costillas del envolvido en espiral (altura baja, misma frecuencia que el color)
    x.globalAlpha = 0.5;
    x.fillStyle = '#5a5a5a'; for (var vr = 0; vr < Hh; vr += 44) x.fillRect(0, vr, W, 7);
    x.fillStyle = '#a6a6a6'; for (var vr2 = 22; vr2 < Hh; vr2 += 44) x.fillRect(0, vr2, W, 5);
    x.globalAlpha = 1;

    // laylines: meseta apenas elevada + bordes nitidos (los 2 filetes del color como crestas)
    var uW = 168;                                        // == 336/2 (misma fraccion, offset.x igual)
    [144, 656].forEach(function (u0) {
      if (st.band) {
        x.fillStyle = '#8c8c8c'; x.fillRect(u0, 0, uW, Hh);
        x.save(); x.beginPath(); x.rect(u0, 0, uW, Hh); x.clip();
        drawWeaveHeight(x, W, Hh);                       // el tejido asoma dentro de la franja
        x.restore();
        x.fillStyle = '#f2f2f2'; x.fillRect(u0 + 5, 0, 3.5, Hh); x.fillRect(u0 + uW - 8, 0, 3.5, Hh);
        x.fillStyle = '#4a4a4a'; x.fillRect(u0 + 8.5, 0, 2, Hh); x.fillRect(u0 + uW - 4.5, 0, 2, Hh);
      }
    });

    var tex = sobelNormalTexture(c, 2.4, {});            // requiere sobelNormalTexture (arriba)
    tex.anisotropy = 16;
    tex.wrapS = tex.wrapT = T.RepeatWrapping;
    tex.offset.x = 0.055;                                // alinea con el color
    // NOTA: buildHose fija normalMap.repeat.y = map.repeat.y para que las crestas
    //       queden en fase con la impresion en cualquier largo.
    return tex;
  }

  /* ============ NORMAL cepillado anisotropo para cromo/acero ============ */
  /* Requiere sobelNormalTexture (definido en normalMapCode). Se construye UNA vez
     en makeMaterials y se comparte entre metales (no es per-build). */
  function makeBrushedNormal() {
    var W = 512, Hh = 512;
    var c = document.createElement('canvas'); c.width = W; c.height = Hh;
    var x = c.getContext('2d');
    x.fillStyle = '#808080'; x.fillRect(0, 0, W, Hh);
    // rayas horizontales finas de intensidad aleatoria -> cepillado en el eje U
    for (var i = 0; i < 2600; i++) {
      var y = Math.random() * Hh;
      var g = (128 + (Math.random() * 2 - 1) * 46) | 0;
      x.strokeStyle = 'rgba(' + g + ',' + g + ',' + g + ',0.5)';
      x.lineWidth = 0.6 + Math.random() * 1.2;
      x.beginPath(); x.moveTo(-4, y); x.lineTo(W + 4, y + (Math.random() * 2 - 1)); x.stroke();
    }
    // pendiente fuerte a lo ANCHO de la raya (Y) y casi nula a lo largo (X) -> anisotropia
    var tex = sobelNormalTexture(c, 1.0, { sx: 0.25, sy: 2.2 });
    tex.wrapS = tex.wrapT = T.RepeatWrapping;
    tex.repeat.set(3, 3);
    tex.anisotropy = 8;
    return tex;
  }

  function makeHoseRoughness() {
    // rugosidad variable: el tejido rompe los brillos (nada de plástico plano)
    var c = document.createElement('canvas'); c.width = 256; c.height = 256;
    var x = c.getContext('2d');
    x.fillStyle = '#93939b'; x.fillRect(0, 0, 256, 256);
    x.lineWidth = 2;
    x.strokeStyle = 'rgba(210,210,214,0.5)';
    for (var i = -256; i < 512; i += 7) { x.beginPath(); x.moveTo(i, 0); x.lineTo(i + 256, 256); x.stroke(); }
    x.strokeStyle = 'rgba(96,96,102,0.55)';
    for (var j = -256; j < 512; j += 7) { x.beginPath(); x.moveTo(j + 256, 0); x.lineTo(j, 256); x.stroke(); }
    var tex = new T.CanvasTexture(c);
    tex.wrapS = tex.wrapT = T.RepeatWrapping; tex.repeat.set(8, 3);
    return tex;
  }

  /* ============ materiales ============ */
  function makeMaterials(env) {
    matChrome = new T.MeshStandardMaterial({ color: 0xffffff, metalness: 1.0, roughness: 0.045, envMap: env, envMapIntensity: 1.15 });
    matSteel  = new T.MeshStandardMaterial({ color: 0xf6f8fa, metalness: 1.0, roughness: 0.13, envMap: env, envMapIntensity: 1.0 });
    matNut    = new T.MeshStandardMaterial({ color: 0xe9edf1, metalness: 1.0, roughness: 0.28, envMap: env, envMapIntensity: 0.95 });
    matDark   = new T.MeshStandardMaterial({ color: 0x1e2126, metalness: 0.85, roughness: 0.42, envMap: env, envMapIntensity: 0.7 });
    matBore   = new T.MeshStandardMaterial({ color: 0x0c0d0f, metalness: 0.4, roughness: 0.85 });
    matRubber = new T.MeshPhysicalMaterial({ color: 0x111318, metalness: 0.0, roughness: 0.72, roughnessMap: makeHoseRoughness(), clearcoat: 0.6, clearcoatRoughness: 0.22, envMap: env, envMapIntensity: 0.55, bumpMap: makeRubberBump(), bumpScale: 0.025 });
    matGhost  = new T.MeshStandardMaterial({ color: 0xce333c, metalness: 0.1, roughness: 0.9, transparent: true, opacity: 0.10 });
    matSlab   = new T.MeshPhysicalMaterial({ color: 0xf7f8fa, metalness: 0.0, roughness: 0.34, clearcoat: 0.55, clearcoatRoughness: 0.22, envMap: env, envMapIntensity: 0.55 });
    matBlock  = new T.MeshStandardMaterial({ color: 0x2b2f34, metalness: 0.55, roughness: 0.48, envMap: env, envMapIntensity: 0.6 });
    matRed    = new T.MeshStandardMaterial({ color: 0xce333c, metalness: 0.35, roughness: 0.45 });
    // metal cepillado: micro-rayas que rompen el espejo plano
    var brushed = makeBrushedNormal();
    matChrome.normalMap = brushed; matChrome.normalScale = new T.Vector2(0.04, 0.04);
    matSteel.normalMap  = brushed; matSteel.normalScale  = new T.Vector2(0.06, 0.06);
    matNut.normalMap    = brushed; matNut.normalScale    = new T.Vector2(0.07, 0.07);
    matDark.normalMap   = brushed; matDark.normalScale   = new T.Vector2(0.05, 0.05);
  }

  /* ============ campana de crimpado (perfil real) ============ */
  function socketProfile() {
    var pts = [];
    function p(x, r) { pts.push(new T.Vector2(r, x)); }
    var R = P.sockR, L = P.sockL;
    p(-0.02, P.hoseR * 0.9);
    p(0.02, R * 0.94);
    p(0.10, R);                          // labio redondeado del extremo libre
    var prev = 0.10;
    P.grooveXs.forEach(function (gx) {   // 5 ranuras de crimpado (líneas finas sobre barril liso)
      p(gx - 0.022, R); p(gx, R - 0.03); p(gx + 0.022, R);
    });
    p(L - 0.16, R);
    p(L - 0.09, R * 0.985);              // canto redondeado
    p(L, P.stepR);                       // caída al escalón
    p(L + P.stepL, P.stepR);             // escalón corto
    p(L + P.stepL + 0.02, P.neckR);      // caída al cuello
    p(L + P.stepL + P.neckL, P.neckR);   // cuello
    return pts;
  }
  function buildSocket() {
    var g = new T.Group();
    var lat = new T.Mesh(new T.LatheGeometry(socketProfile(), 72), matSteel);
    lat.rotation.z = -Math.PI / 2;
    g.add(lat);
    // collares de alivio pulidos (anillos oscuros finos) cerca de ambos extremos
    var ring = new T.Mesh(new T.TorusGeometry(P.sockR - 0.008, 0.016, 8, 48), matBlock);
    ring.rotation.y = Math.PI / 2; ring.position.x = 0.152; g.add(ring);
    // ranuras finas del cuello
    var r2 = new T.Mesh(new T.TorusGeometry(P.neckR - 0.008, 0.018, 8, 40), matBlock);
    r2.rotation.y = Math.PI / 2; r2.position.x = P.sockL + P.stepL + 0.2; g.add(r2);
    g.userData.endX = P.sockL + P.stepL + P.neckL;
    return g;
  }

  /* ============ tuerca hexagonal con biseles ============ */
  function hexNut(afDist, len, mat) {
    var Rc = (afDist / 2) / Math.cos(Math.PI / 6);   // circunradio desde entre-caras
    var g = new T.Group();
    var body = new T.Mesh(new T.CylinderGeometry(Rc, Rc, len * 0.68, 6), mat);
    body.rotation.z = Math.PI / 2; body.rotation.x = Math.PI / 6; g.add(body);
    var bev1 = new T.Mesh(new T.CylinderGeometry(Rc * 0.84, Rc, len * 0.16, 6), mat);
    bev1.rotation.z = Math.PI / 2; bev1.rotation.x = Math.PI / 6; bev1.position.x = len * 0.42; g.add(bev1);
    var bev2 = new T.Mesh(new T.CylinderGeometry(Rc, Rc * 0.84, len * 0.16, 6), mat);
    bev2.rotation.z = Math.PI / 2; bev2.rotation.x = Math.PI / 6; bev2.position.x = -len * 0.42; g.add(bev2);
    return g;
  }

  /* ============ extremo MACHO: tuerca + rosca fina + cono JIC ============ */
  function buildMaleEnd() {
    var g = new T.Group();
    var nut = hexNut(P.hexAF, P.hexL, matNut);
    nut.position.x = P.hexL / 2; g.add(nut);
    var x0 = P.hexL + 0.02;
    var core = new T.Mesh(new T.CylinderGeometry(P.threadRoot, P.threadRoot, P.threadL + 0.05, 36), matChrome);
    core.rotation.z = Math.PI / 2; core.position.x = x0 + P.threadL / 2; g.add(core);
    var n = Math.floor(P.threadL / P.threadPitch);
    for (var i = 0; i < n; i++) {                     // hilos: crestas torus a paso real
      var th = new T.Mesh(new T.TorusGeometry(lerp(P.threadMajor, P.threadMajor * 0.985, i / n), 0.06, 8, 36), matSteel);
      th.rotation.y = Math.PI / 2;
      th.position.x = x0 + 0.085 + i * P.threadPitch;
      g.add(th);
    }
    var xc = x0 + P.threadL;
    var nose = new T.Mesh(new T.CylinderGeometry(P.noseR, P.threadRoot, P.noseL, 36), matChrome);
    nose.rotation.z = Math.PI / 2; nose.position.x = xc + P.noseL / 2; g.add(nose);
    var face = new T.Mesh(new T.CircleGeometry(P.noseR, 28), matChrome);
    face.rotation.y = Math.PI / 2; face.position.x = xc + P.noseL + 0.002; g.add(face);
    var hole = new T.Mesh(new T.CircleGeometry(P.noseR * 0.55, 22), matBore);
    hole.rotation.y = Math.PI / 2; hole.position.x = xc + P.noseL + 0.006; g.add(hole);
    g.userData.endX = xc + P.noseL;
    return g;
  }

  /* ============ extremo HEMBRA: tuerca + barril moleteado + boca avellanada ============ */
  function buildFemaleEnd() {
    var g = new T.Group();
    var nut = hexNut(P.hexAF, P.hexL, matNut);
    nut.position.x = P.hexL / 2; g.add(nut);
    var x0 = P.hexL;
    var swv = new T.Mesh(new T.CylinderGeometry(P.swvR, P.swvR, P.swvL, 48), matNut.clone());
    swv.material.userData.disposable = true; swv.material.userData.disposeBump = true;
    swv.material.bumpMap = makeKnurlBump(); swv.material.bumpScale = 0.02;
    swv.rotation.z = Math.PI / 2; swv.position.x = x0 + P.swvL / 2; g.add(swv);
    // collares pulidos sin moleteado en ambos bordes del barril
    [x0 + 0.07, x0 + P.swvL - 0.07].forEach(function (xx) {
      var cl = new T.Mesh(new T.CylinderGeometry(P.swvR * 1.004, P.swvR * 1.004, 0.11, 48), matSteel);
      cl.rotation.z = Math.PI / 2; cl.position.x = xx; g.add(cl);
    });
    var fx = x0 + P.swvL + 0.065;
    // frente: anillo de cara + barreno con cono de asiento 37°
    var rim = new T.Mesh(new T.CylinderGeometry(P.swvR * 0.9, P.swvR, 0.13, 48), matSteel);
    rim.rotation.z = Math.PI / 2; rim.position.x = fx - 0.065; g.add(rim);
    var face = new T.Mesh(new T.RingGeometry(P.boreR, P.swvR * 0.9, 44), matNut);
    face.rotation.y = -Math.PI / 2; face.rotation.z = Math.PI; face.position.x = fx; g.add(face);
    var seat = new T.Mesh(new T.CylinderGeometry(P.boreR, P.boreR * 0.42, 0.52, 36, 1, true), matBore);
    seat.rotation.z = Math.PI / 2; seat.position.x = fx - 0.26; g.add(seat);
    // ranura externa justo detrás de la boca (o-ring / alivio)
    var gr = new T.Mesh(new T.TorusGeometry(P.swvR * 0.93, 0.03, 8, 44), matDark);
    gr.rotation.y = Math.PI / 2; gr.position.x = fx - 0.16; g.add(gr);
    g.userData.endX = fx;
    return g;
  }

  /* ============ codo: tubo doblado radio 1.304R + collar ============ */
  function buildElbowTube(kind) {
    var ang = kind === 'codo45' ? Math.PI / 4 : Math.PI / 2;
    var R = P.bendR, extra = P.armExtra[kind] || 0.18;
    var pts = [], steps = 30;
    pts.push(new T.Vector3(-0.06, 0, 0));            // solape hacia el cuello
    for (var i = 0; i <= steps; i++) {
      var a = (i / steps) * ang;
      pts.push(new T.Vector3(Math.sin(a) * R, R - Math.cos(a) * R, 0));
    }
    var ux = Math.cos(ang), uy = Math.sin(ang);
    var ex = Math.sin(ang) * R, ey = R - Math.cos(ang) * R;
    var endLen = P.elbowCollar + extra;
    pts.push(new T.Vector3(ex + ux * endLen, ey + uy * endLen, 0));
    var curve = new T.CatmullRomCurve3(pts, false, 'catmullrom', 0.0);
    var g = new T.Group();
    var tube = new T.Mesh(new T.TubeGeometry(curve, 56, P.tubeR, 24, false), matChrome);
    g.add(tube);
    // collar + anillo de sombra donde se une la cabeza (como en las fotos)
    var cEnd = new T.Vector3(ex + ux * endLen, ey + uy * endLen, 0);
    var collar = new T.Mesh(new T.CylinderGeometry(P.neckR * 1.12, P.neckR * 1.12, 0.3, 36), matSteel);
    collar.rotation.z = ang - Math.PI / 2;
    collar.position.set(cEnd.x - ux * 0.15, cEnd.y - uy * 0.15, 0); g.add(collar);
    g.userData.exit = { pos: cEnd, ang: ang };
    return g;
  }

  /* ============ conexión completa ============ */
  function buildFitting(spec) {
    var g = new T.Group();
    var sock = buildSocket(); g.add(sock);
    var after = sock.userData.endX;
    var end = (spec.gender === 'hembra') ? buildFemaleEnd() : buildMaleEnd();
    if (spec.geom && spec.geom !== 'recta') {
      var elb = buildElbowTube(spec.geom);
      elb.position.x = after; g.add(elb);
      var ex = elb.userData.exit;
      end.position.set(after + ex.pos.x, ex.pos.y, 0);
      end.rotation.z = ex.ang;
      g.add(end);
    } else {
      end.position.x = after; g.add(end);
    }
    g.scale.setScalar(WORLD_R);
    return g;
  }

  /* ============ manguera (franja layline real por familia) ============ */
  function buildHose(halfLen, label) {
    var g = new T.Group();
    var R = P.hoseR * WORLD_R, L = halfLen * 2;
    var fam = familyOf(label);
    var m = matRubber.clone();
    m.userData.disposable = true;                 // clon por-build: liberar en rebuild
    m.color.setHex(0xffffff);                     // el color vive en la textura
    m.map = makeHoseTexture(fam);
    m.map.repeat.set(1, Math.max(1, L / 3.6));   // impresión con densidad constante en cualquier largo
    if (fam && FAMILIES[fam] && FAMILIES[fam].cover) { m.envMapIntensity = 0.32; m.clearcoat = 0.35; }
    m.normalMap = makeHoseNormal(fam);
    m.normalMap.repeat.set(1, Math.max(1, L / 3.6));   // en fase con el color
    m.normalScale = new T.Vector2(0.85, 0.85);
    if (fam && FAMILIES[fam] && FAMILIES[fam].cover) m.normalScale.set(0.7, 0.7);
    m.bumpMap = null;                                  // el tejido ya vive en el normal
    m.userData.disposeNormal = true;
    var capMat = matBore;                        // tapas de corte en negro (no la textura envuelta)
    var body = new T.Mesh(new T.CylinderGeometry(R, R, L, 64), [m, capMat, capMat]);
    body.rotation.z = Math.PI / 2; g.add(body);
    return g;
  }
  function hoseHalfLen(meters) {
    return lerp(1.5, 3.15, Math.min(1, Math.max(0, ((meters || 1) - 0.5) / 12)));
  }

  /* ============ banco de trabajo (soporte) ============ */
  // decal de oclusión de contacto (quad barato: aterriza las piezas sin post-procesado)
  var _decalTex = null;
  function makeContactDecal() {
    var c = document.createElement('canvas'); c.width = 128; c.height = 128;
    var x = c.getContext('2d');
    var g = x.createRadialGradient(64, 64, 2, 64, 64, 62);
    g.addColorStop(0, 'rgba(6,7,9,0.55)'); g.addColorStop(0.5, 'rgba(6,7,9,0.22)'); g.addColorStop(1, 'rgba(6,7,9,0)');
    x.fillStyle = g; x.fillRect(0, 0, 128, 128);
    return new T.CanvasTexture(c);
  }
  function contactDecal(sx, sz, alpha) {
    if (!_decalTex) _decalTex = makeContactDecal();
    var m = new T.MeshBasicMaterial({ map: _decalTex, transparent: true, opacity: (alpha == null ? 1 : alpha), depthWrite: false });
    var d = new T.Mesh(new T.PlaneGeometry(sx, sz), m);
    d.rotation.x = -Math.PI / 2; d.renderOrder = 2;
    return d;
  }
  function makeShadowTexture() {
    var c = document.createElement('canvas'); c.width = 512; c.height = 256;
    var x = c.getContext('2d');
    var g = x.createRadialGradient(256, 128, 8, 256, 128, 240);
    g.addColorStop(0.00, 'rgba(14,16,20,0.42)'); g.addColorStop(0.35, 'rgba(14,16,20,0.26)');
    g.addColorStop(0.70, 'rgba(14,16,20,0.08)'); g.addColorStop(1.00, 'rgba(14,16,20,0)');
    x.fillStyle = g; x.beginPath(); x.ellipse(256, 128, 250, 104, 0, 0, Math.PI * 2); x.fill();
    var g2 = x.createRadialGradient(256, 128, 4, 256, 128, 120);
    g2.addColorStop(0, 'rgba(8,9,12,0.34)'); g2.addColorStop(1, 'rgba(8,9,12,0)');
    x.fillStyle = g2; x.beginPath(); x.ellipse(256, 128, 150, 44, 0, 0, Math.PI * 2); x.fill();
    return new T.CanvasTexture(c);
  }
  function saddleFin(H) {
    // CUNA DE BANCO (roller/saddle de banco hidraulico): pedestal oscuro con una
    // GARGANTA SEMICIRCULAR maquinada donde DESCANSA la manguera, forrada de cromo,
    // con disco de acento rojo en la base.
    //
    // INTERSECCION IMPOSIBLE POR CONSTRUCCION:
    //   - El grupo saddleFin vive en world (x, -1.44, HOSE_Z).
    //   - Eje de la manguera (world) Y = HOSE_Y + lift = -0.72 + lift  ->  LOCAL Y = H
    //     (con H = 0.72 + lift). Por eso el CENTRO de la garganta = topY = H = eje real.
    //   - TODO el material del pedestal vive en Y <= topY (nunca por encima del eje) y a
    //     una distancia del eje >= rGroove (0.35) > R (0.30). La garganta se ESCARBA con
    //     radio rGroove, asi que la superficie de asiento queda siempre FUERA del cilindro
    //     de la manguera. Verificado numericamente (cradle-check.js): holgura 0.045 en
    //     lift 0 y 0.5, identica en cualquier lift (todo es relativo a topY=H).
    H = (typeof H === 'number') ? H : 0.72;
    var grp = new T.Group();

    var topY    = H;                     // borde/eje de la garganta = eje real de la manguera
    var rGroove = WORLD_R + 0.034;       // 0.334 . radio de la escarba (asentada, nunca dentro)
    var rLiner  = WORLD_R + 0.026;       // 0.326 . piel de cromo (holgura fina: se VE asentada)
    var W       = 0.44;                  // medio ancho del cabezal en Z
    var saddleW = 0.52;                  // profundidad del cabezal a lo largo de X (eje manguera)
    var ch      = 0.05;                  // chaflan de las esquinas superiores
    var br      = 0.06;                  // redondeo de las esquinas inferiores
    var headBottom = topY - rGroove - 0.07;   // base del cabezal (más compacto)

    /* ---- CABEZAL: prisma extruido con GARGANTA semicircular escarbada arriba ----
       Seccion (u=Z horizontal, v=Y vertical); la escarba es el semicirculo INFERIOR
       de radio rGroove centrado en (0, topY). Sin bevel: nada sube por encima de topY. */
    var s = new T.Shape();
    s.moveTo(-W, headBottom + br);
    s.lineTo(-W, topY - ch);
    s.lineTo(-W + ch, topY);                       // chaflan sup-izq
    s.lineTo(-rGroove, topY);                       // hombro plano izq
    s.absarc(0, topY, rGroove, Math.PI, Math.PI * 2, false); // garganta (semicirculo inferior)
    s.lineTo(W - ch, topY);                         // hombro plano der
    s.lineTo(W, topY - ch);                         // chaflan sup-der
    s.lineTo(W, headBottom + br);
    s.quadraticCurveTo(W, headBottom, W - br, headBottom);
    s.lineTo(-W + br, headBottom);
    s.quadraticCurveTo(-W, headBottom, -W, headBottom + br);
    var headGeo = new T.ExtrudeGeometry(s, { depth: saddleW, bevelEnabled: false, curveSegments: 40 });
    var head = new T.Mesh(headGeo, matBlock);
    head.rotation.y = Math.PI / 2;                  // extrusion Z -> eje X (a lo largo de la manguera)
    head.position.x = -saddleW / 2;                 // centrar en X
    grp.add(head);

    /* ---- FORRO DE CROMO: media cana pulida sobre la escarba (donde apoya el hule) ----
       Cilindro abierto, mitad inferior (thetaStart=PI, len=PI), eje llevado a X. */
    var linerMat = matChrome.clone();
    linerMat.side = T.DoubleSide;                   // cara concava visible desde arriba
    linerMat.userData.disposable = true;
    var liner = new T.Mesh(
      new T.CylinderGeometry(rLiner, rLiner, saddleW * 0.94, 48, 1, true, Math.PI, Math.PI),
      linerMat);
    liner.rotation.z = Math.PI / 2;                 // eje del cilindro -> X ; media cana abre hacia arriba
    liner.position.y = topY;                        // rim exactamente en el eje; cana por debajo
    grp.add(liner);

    /* ---- Trim cromado en los dos labios de la garganta (aspecto maquinado) ---- */
    [-1, 1].forEach(function (sg) {
      var trim = new T.Mesh(new T.BoxGeometry(saddleW * 0.96, 0.02, 0.032), matChrome);
      trim.position.set(0, topY - 0.01, sg * rGroove);   // tope en topY, |Z|=0.35 > R
      grp.add(trim);
    });

    /* ---- Tornillos cromados en las mejillas laterales (|Z| = W = 0.44 > R) ---- */
    [-1, 1].forEach(function (sg) {
      var bolt = new T.Mesh(new T.CylinderGeometry(0.032, 0.032, 0.03, 16), matChrome);
      bolt.rotation.x = Math.PI / 2;                       // eje del perno -> Z
      bolt.position.set(0, topY - 0.28, sg * W);
      grp.add(bolt);
    });

    /* ---- Poste esbelto + collar cromado ---- */
    var baseTop = 0.055;
    var postH = Math.max(0.1, headBottom - baseTop);
    var post = new T.Mesh(new T.CylinderGeometry(0.058, 0.078, postH, 22), matBlock);
    post.position.y = baseTop + postH / 2; grp.add(post);
    var collar = new T.Mesh(new T.CylinderGeometry(0.085, 0.105, 0.06, 20), matChrome);
    collar.position.y = headBottom - 0.01; grp.add(collar);
    var footCollar = new T.Mesh(new T.CylinderGeometry(0.085, 0.095, 0.045, 20), matChrome);
    footCollar.position.y = baseTop + 0.02; grp.add(footCollar);

    /* ---- Base circular + disco de acento ROJO ---- */
    var base = new T.Mesh(new T.CylinderGeometry(0.24, 0.28, 0.055, 28), matBlock);
    base.position.y = 0.028; grp.add(base);
    var accent = new T.Mesh(new T.CylinderGeometry(0.285, 0.285, 0.014, 28), matRed);
    accent.position.y = 0.007; grp.add(accent);
    // oclusión de contacto bajo la base (mundo ~-1.392: apenas sobre la losa)
    var cd = contactDecal(0.95, 0.72, 0.9); cd.position.y = 0.049; grp.add(cd);

    return grp;
  }
  function buildStand() {
    var g = new T.Group();
    var slabShape = new T.Shape();
    var W = 4.7, D = 1.3, r = 0.3;
    slabShape.moveTo(-W + r, -D); slabShape.lineTo(W - r, -D); slabShape.quadraticCurveTo(W, -D, W, -D + r);
    slabShape.lineTo(W, D - r); slabShape.quadraticCurveTo(W, D, W - r, D);
    slabShape.lineTo(-W + r, D); slabShape.quadraticCurveTo(-W, D, -W, D - r);
    slabShape.lineTo(-W, -D + r); slabShape.quadraticCurveTo(-W, -D, -W + r, -D);
    var slab = new T.Mesh(new T.ExtrudeGeometry(slabShape, { depth: 0.13, bevelEnabled: true, bevelThickness: 0.035, bevelSize: 0.035, bevelSegments: 3 }), matSlab);
    slab.rotation.x = -Math.PI / 2; slab.position.y = -1.6;
    slab.receiveShadow = true;
    g.add(slab);
    var edge = new T.Mesh(new T.BoxGeometry(W * 2 * 0.98, 0.026, 0.05), matRed);
    edge.position.set(0, -1.425, D + 0.02); g.add(edge);
    var sh = new T.Mesh(new T.PlaneGeometry(6.6, 3.0),
      new T.MeshBasicMaterial({ map: makeShadowTexture(), transparent: true, depthWrite: false }));
    sh.rotation.x = -Math.PI / 2; sh.position.y = -1.40; sh.position.z = 0.5; g.add(sh);
    var b1 = saddleFin(), b2 = saddleFin();
    b1.position.set(-1.15, -1.44, HOSE_Z); b2.position.set(1.15, -1.44, HOSE_Z);
    b1.name = 'vblock1'; b2.name = 'vblock2';
    castAll(b1); castAll(b2);
    g.add(b1); g.add(b2);
    return g;
  }
  var finLift = 0;
  function placeBlocks(halfLen, lift) {
    lift = lift || 0;
    // cunas SIEMPRE bajo el hule (lejos de las campanas de crimpado) y a la altura correcta
    if (Math.abs(lift - finLift) > 0.01) {
      finLift = lift;
      ['vblock1', 'vblock2'].forEach(function (nm) {
        var old = standGroup.getObjectByName(nm);
        if (old) { standGroup.remove(old); disposeDeep(old); }
        var nf = saddleFin(0.72 + lift);
        nf.name = nm;
        nf.position.set(0, -1.44, HOSE_Z);
        castAll(nf);
        standGroup.add(nf);
      });
    }
    var b1 = standGroup.getObjectByName('vblock1'), b2 = standGroup.getObjectByName('vblock2');
    var x = Math.max(0.5, Math.min(halfLen - 1.05, halfLen * 0.6));
    if (b1) b1.position.x = -x;
    if (b2) b2.position.x = x;
  }

  /* ============ estado fantasma ============ */
  function buildGhost() {
    var g = new T.Group();
    var body = new T.Mesh(new T.CylinderGeometry(WORLD_R, WORLD_R, 3.4, 28), matGhost);
    body.rotation.z = Math.PI / 2; g.add(body);
    var e1 = new T.Mesh(new T.CylinderGeometry(WORLD_R * 1.11, WORLD_R * 1.11, 0.72, 28), matGhost);
    e1.rotation.z = Math.PI / 2; e1.position.x = -2.0; g.add(e1);
    var e2 = e1.clone(); e2.position.x = 2.0; g.add(e2);
    return g;
  }

  /* ============ montaje animado ============ */
  function mount(slot, obj, dirX) {
    groups[slot] = obj;
    castAll(obj);
    asm.add(obj);
    var fx = obj.position.x, baseScale = obj.scale.x;
    tween(560, function (k) {
      obj.position.x = fx + dirX * (1 - k) * 1.3;
      obj.scale.setScalar(baseScale * (0.6 + 0.4 * k));
    }, easeOutBack);
  }

  /* la manguera queda a la altura de las cunas en V */
  var HOSE_Y = -0.72;
  var HOSE_Z = 0.62;   // cerca del borde frontal: un codo hacia abajo cuelga fuera de la losa

  /* ============ update: reconstruye solo lo que cambió ============ */
  var lastHalf = null, curLift = 0;
  K.update = function (st) {
    if (!ready) { K.__pending = st; return; }
    st = st || {};
    var half = hoseHalfLen(st.meters);
    var ghost = !st.hose && !st.A && !st.B;
    var lenChanged = (lastHalf !== null && Math.abs(half - lastHalf) > 0.001);

    var hoseKey = st.hose ? st.hose.label : (ghost ? 'ghost' : 'none');
    if (hoseKey !== keys.hose) {
      keys.hose = hoseKey;
      if (groups.hose) { asm.remove(groups.hose); disposeDeep(groups.hose); groups.hose = null; }
      if (st.hose) {
        var h = buildHose(half, st.hose.label);
        groups.hose = h; castAll(h); asm.add(h);
        tween(460, function (k) { h.scale.set(Math.max(0.12, k), 1, 1); });
      } else if (ghost) {
        groups.hose = buildGhost(); asm.add(groups.hose);
      }
    } else if (lenChanged && st.hose && groups.hose) {
      // LONGITUD: la manguera CRECE/ENCOGE fluida (no aparece de la nada)
      var oldHalf = lastHalf;
      asm.remove(groups.hose); disposeDeep(groups.hose);
      var h2 = buildHose(half, st.hose.label);
      groups.hose = h2; castAll(h2); asm.add(h2);
      h2.scale.set(Math.max(0.05, oldHalf / half), 1, 1);
      tween(520, function (k) { h2.scale.set(lerp(Math.max(0.05, oldHalf / half), 1, k), 1, 1); });
    }

    ['A', 'B'].forEach(function (side) {
      var spec = st[side];
      var key = spec ? (spec.geom + '|' + spec.gender) : 'none';
      var targetX = (side === 'A') ? (-half + 0.26 * WORLD_R) : (half - 0.26 * WORLD_R);
      if (key === keys[side]) {
        // misma pieza: si cambió el largo, se DESLIZA a su nueva posición
        var gEx = groups[side];
        if (gEx && Math.abs(gEx.position.x - targetX) > 0.002) {
          var fromX = gEx.position.x;
          tween(520, function (k) { gEx.position.x = lerp(fromX, targetX, k); });
        }
        return;
      }
      keys[side] = key;
      if (groups[side]) { asm.remove(groups[side]); disposeDeep(groups[side]); groups[side] = null; }
      if (!spec) return;
      var f = buildFitting(spec);
      if (side === 'A') { f.rotation.y = Math.PI; }
      f.position.x = targetX;
      f.userData.justBuilt = true;
      mount(side, f, side === 'A' ? -1 : 1);
    });

    // giro del extremo B (solo codo-a-codo): fijar destino, luego animar
    var targetRot = 0;
    if (st.B && st.A && st.A.geom !== 'recta' && st.B.geom !== 'recta') {
      targetRot = (st.angleB || 0) * Math.PI / 180;
    }
    if (groups.B) {
      var fromRot = groups.B.rotation.x;
      groups.B.rotation.x = targetRot;                 // destino real (para medir contra la losa)
      if (!groups.B.userData.justBuilt && Math.abs(targetRot - fromRot) > 0.001) {
        var objB = groups.B;
        tween(420, function (k) { objB.rotation.x = lerp(fromRot, targetRot, k); });
      }
      groups.B.userData.justBuilt = false;
    }

    // NUNCA atravesar la losa: si un codo cuelga por debajo, TODO el ensamble sube
    // y las cunas crecen con él (banco adaptivo).
    asm.position.y = HOSE_Y;
    asm.updateMatrixWorld(true);
    var bb = new T.Box3().setFromObject(asm);
    var lift = Math.max(0, -1.40 - bb.min.y);
    placeBlocks(Math.max(half, 1.4), lift);
    var startY = HOSE_Y + curLift, endY = HOSE_Y + lift;
    if (Math.abs(endY - startY) > 0.005 && !reduced) {
      asm.position.y = startY;
      tween(460, function (k) { asm.position.y = lerp(startY, endY, k); });
    } else {
      asm.position.y = endY;
    }
    curLift = lift;
    var mustFrame = lenChanged || (lastHalf === null && st.hose);
    lastHalf = half;
    if (mustFrame) frameAssembly();
  };

  /* encuadre automático: calcula la distancia para que TODO el ensamble quepa con aire */
  function frameAssembly() {
    if (!camera || !asm) return;
    // medir con la manguera en su escala FINAL (el rebuild de longitud arranca a media escala)
    var hs = groups.hose ? groups.hose.scale.clone() : null;
    if (groups.hose) groups.hose.scale.set(1, 1, 1);
    asm.updateMatrixWorld(true);
    var bb = new T.Box3().setFromObject(asm);
    if (groups.hose && hs) groups.hose.scale.copy(hs);
    if (!isFinite(bb.min.x)) return;
    var sph = new T.Sphere(); bb.getBoundingSphere(sph);
    var vFov = camera.fov * Math.PI / 180;
    var hFov = 2 * Math.atan(Math.tan(vFov / 2) * Math.max(0.6, camera.aspect || 1));
    var half = Math.min(vFov, hFov) / 2;
    var d = (sph.radius / Math.sin(half)) * 1.04 + 0.4;   // esfera envolvente: cabe gire como gire
    targetDist = Math.max(5.4, Math.min(16.5, d));
  }

  /* ============ órbita ============ */
  function setupOrbit(canvas) {
    var lx = 0, ly = 0;
    function down(e) { dragging = true; K.stopTour(); var t = e.touches ? e.touches[0] : e; lx = t.clientX; ly = t.clientY; }
    function move(e) {
      if (!dragging) return;
      var t = e.touches ? e.touches[0] : e;
      targetRotY += (t.clientX - lx) * 0.0085;
      targetRotX += (t.clientY - ly) * 0.0085;
      targetRotX = Math.max(-0.5, Math.min(1.1, targetRotX));
      lx = t.clientX; ly = t.clientY;
      if (e.cancelable) e.preventDefault();
    }
    function up() { dragging = false; }
    canvas.addEventListener('mousedown', down);
    root.addEventListener('mousemove', move);
    root.addEventListener('mouseup', up);
    canvas.addEventListener('touchstart', down, { passive: true });
    canvas.addEventListener('touchmove', move, { passive: false });
    root.addEventListener('touchend', up);
    canvas.addEventListener('wheel', function (e) {
      targetDist = Math.max(5.0, Math.min(17, targetDist + e.deltaY * 0.011));
      e.preventDefault();
    }, { passive: false });
  }

  /* tour: recorre puntos de captura del producto (¾ frontal, lateral, cenital, detalle…) */
  var tourOn = false, tourIdx = 0, tourLast = 0;
  var TOUR = [
    { x: 0.34, y: -0.55, d: 8.7 },   // ¾ frontal izquierda
    { x: 0.10, y:  0.85, d: 6.6 },   // lateral derecha, cerca
    { x: 0.55, y:  2.35, d: 7.8 },   // ¾ trasera elevada
    { x: 0.05, y:  3.70, d: 6.2 },   // frente bajo, detalle rosca
    { x: 0.78, y:  5.25, d: 9.4 },   // cenital amplia
    { x: 0.26, y:  6.85, d: 7.0 }    // ¾ frontal derecha
  ];
  K.startTour = function () { tourOn = true; autoRotate = false; tourIdx = 0; tourLast = 0; };
  K.stopTour = function () { if (!tourOn) return; tourOn = false; if (K.onTourEnd) K.onTourEnd(); };
  K.isTour = function () { return tourOn; };
  K.setAutoRotate = function (v) { autoRotate = !!v; if (v) K.stopTour(); };
  K.resetView = function () { K.stopTour(); targetRotX = 0.34; targetRotY = -0.55; targetDist = 8.7; };

  /* ============ bucle ============ */
  function setupPostFX() {
    if (!T.EffectComposer || !T.SSAOPass || !T.UnrealBloomPass) return null;   // bundle ausente → render directo
    try {
      var size = renderer.getSize(new T.Vector2());
      var comp = new T.EffectComposer(renderer);
      comp.setPixelRatio(renderer.getPixelRatio());
      comp.setSize(size.x, size.y);
      comp.addPass(new T.RenderPass(scene, camera));
      var ssao = new T.SSAOPass(scene, camera, size.x, size.y);
      ssao.kernelRadius = 0.6;      // AO ceñido: contactos y ranuras, no caras amplias
      ssao.minDistance = 0.0025;
      ssao.maxDistance = 0.06;
      comp.addPass(ssao);
      var bloom = new T.UnrealBloomPass(new T.Vector2(size.x, size.y), 0.22, 0.3, 0.93);
      comp.addPass(bloom);          // umbral MUY alto: solo los picos especulares del cromo
      // r128: el composer rinde en LINEAL (ignora renderer.outputEncoding) → corregir a sRGB al final
      var gamma = new T.ShaderPass({
        uniforms: { tDiffuse: { value: null } },
        vertexShader: 'varying vec2 vUv; void main(){ vUv = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position,1.0); }',
        fragmentShader: 'uniform sampler2D tDiffuse; varying vec2 vUv; void main(){ vec4 c = texture2D(tDiffuse, vUv); vec3 lo = c.rgb * 12.92; vec3 hi = 1.055 * pow(max(c.rgb, vec3(0.0)), vec3(1.0/2.4)) - 0.055; vec3 srgb = mix(lo, hi, step(vec3(0.0031308), c.rgb)); gl_FragColor = vec4(srgb, c.a); }'
      });
      comp.addPass(gamma);
      return comp;
    } catch (e) { return null; }
  }

  function animate(now) {
    requestAnimationFrame(animate);
    stepTweens(now || performance.now());
    if (tourOn && !dragging) {
      if (!tourLast || (now - tourLast) > 2700) {
        tourLast = now || performance.now();
        var wp = TOUR[tourIdx % TOUR.length]; tourIdx++;
        targetRotX = wp.x; targetRotY = wp.y; targetDist = wp.d;
      }
    } else if (autoRotate && !dragging && !reduced) targetRotY += 0.0022;
    rotX = lerp(rotX, targetRotX, 0.12);
    rotY = lerp(rotY, targetRotY, 0.12);
    dist = lerp(dist, targetDist, 0.12);
    world.rotation.x = rotX; world.rotation.y = rotY;
    camera.position.set(0, 1.05, dist);
    camera.lookAt(0, -0.38 + curLift * 0.55, 0);   // el encuadre sigue al ensamble si se eleva
    if (composer) composer.render();
    else renderer.render(scene, camera);
  }

  function resize() {
    if (!holderEl) return;
    var w = holderEl.clientWidth, h = holderEl.clientHeight;
    if (!w || !h) return;
    renderer.setPixelRatio(Math.min(root.devicePixelRatio || 1, 2));
    renderer.setSize(w, h, false);
    camera.aspect = w / h;
    camera.updateProjectionMatrix();
    if (composer) { composer.setPixelRatio(Math.min(root.devicePixelRatio || 1, 2)); composer.setSize(w, h); }
  }
  K.resize = resize;

  /* ============ init ============ */
  K.init = function (opts) {
    if (ready) return true;                        // guarda: init una sola vez
    var canvas = opts.canvas;
    holderEl = opts.holder || canvas.parentElement;
    try {
      renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true });
    } catch (e) { return false; }
    renderer.setPixelRatio(Math.min(root.devicePixelRatio || 1, 2));
    renderer.outputEncoding = T.sRGBEncoding;
    renderer.toneMapping = T.ACESFilmicToneMapping;
    renderer.toneMappingExposure = 1.05;
    renderer.physicallyCorrectLights = false;   // escala clásica r128: el rig está calibrado así
    renderer.shadowMap.enabled = true;
    renderer.shadowMap.type = T.PCFSoftShadowMap;

    scene = new T.Scene();
    camera = new T.PerspectiveCamera(46, 1, 0.1, 100);

    var envTex = makeEnvTexture();
    var pmrem = new T.PMREMGenerator(renderer);
    var env = pmrem.fromEquirectangular(envTex).texture;
    envTex.dispose(); pmrem.dispose();
    makeMaterials(env);

    var hemi = new T.HemisphereLight(0xeaf1ff, 0xbeb6ab, 0.30); scene.add(hemi);
    // KEY: forma + sombra de contacto (fuerte, con frustum ceñido al banco)
    var key = new T.DirectionalLight(0xfff6ec, 2.10); key.position.set(5.2, 8.5, 4.2);
    key.castShadow = true;
    key.shadow.mapSize.set(2048, 2048);
    key.shadow.camera.near = 2;    key.shadow.camera.far = 22;
    key.shadow.camera.left = -5.4; key.shadow.camera.right = 5.4;
    key.shadow.camera.top = 4.6;   key.shadow.camera.bottom = -4.6;
    key.shadow.bias = -0.00035; key.shadow.normalBias = 0.022; key.shadow.radius = 5;
    scene.add(key);
    key.target.position.set(0, -1.0, 0.3); scene.add(key.target); key.target.updateMatrixWorld();
    var cool  = new T.DirectionalLight(0xcfe0ff, 0.55); cool.position.set(6.5, 2.4, -4.8); scene.add(cool);   // canto frío
    var rim   = new T.DirectionalLight(0xffb2b6, 0.70); rim.position.set(-6.8, 2.8, -3.6); scene.add(rim);    // beso rojo de marca
    var spark = new T.DirectionalLight(0xffffff, 0.26); spark.position.set(-1.5, 9, 1.5); scene.add(spark);
    var front = new T.DirectionalLight(0xffffff, 0.16); front.position.set(0, 1.4, 9); scene.add(front);
    scene.environment = env;   // IBL global consistente

    // ciclorama de estudio (fijo a cámara: no gira con el modelo)
    (function () {
      var bc = document.createElement('canvas'); bc.width = 1024; bc.height = 512;
      var bx = bc.getContext('2d');
      var bg = bx.createLinearGradient(0, 0, 0, 512);
      bg.addColorStop(0, '#ffffff'); bg.addColorStop(0.55, '#f6f7f9'); bg.addColorStop(1, '#e9ebee');
      bx.fillStyle = bg; bx.fillRect(0, 0, 1024, 512);
      var br = bx.createRadialGradient(790, 130, 20, 790, 130, 420);
      br.addColorStop(0, 'rgba(206,51,60,0.14)'); br.addColorStop(1, 'rgba(206,51,60,0)');
      bx.fillStyle = br; bx.fillRect(0, 0, 1024, 512);
      var bl = bx.createRadialGradient(140, 420, 20, 140, 420, 380);
      bl.addColorStop(0, 'rgba(206,51,60,0.07)'); bl.addColorStop(1, 'rgba(206,51,60,0)');
      bx.fillStyle = bl; bx.fillRect(0, 0, 1024, 512);
      var btex = new T.CanvasTexture(bc);
      var back = new T.Mesh(new T.PlaneGeometry(70, 34), new T.MeshBasicMaterial({ map: btex, depthWrite: false }));
      back.position.set(0, 3, -11); back.renderOrder = -10;
      scene.add(back);
    })();
    world = new T.Group(); scene.add(world);
    standGroup = buildStand(); world.add(standGroup);
    asm = new T.Group(); asm.position.y = HOSE_Y; asm.position.z = HOSE_Z; world.add(asm);

    composer = setupPostFX();
    setupOrbit(canvas);
    root.addEventListener('resize', resize);
    resize();
    ready = true; K.ready = true;
    animate();
    if (K.__pending) { var s = K.__pending; K.__pending = null; K.update(s); }
    else K.update({});
    return true;
  };

  root.Kit3D = K;
})(typeof window !== 'undefined' ? window : this);
